import { LocalDateTime } from 'src/main/angular/app/shared/jsr310-localdates/types/local-date-time.type';
import { UpdateAccesOrder } from './update-acces-order.entity';

export class UpdatePlannedAccesOrder extends UpdateAccesOrder {
	ouvragesConcernesIds!: number[];
	typeAcces!: string;
	dateDebut!: LocalDateTime;
	accesCegex!: boolean;

	constructor() {
		super();
	}
}